// import {
//   Button,
//   Flex,
//   Heading
// } from "@chakra-ui/react";

// import { FiPlus } from "react-icons/fi";

// interface Props {
//   title: string;
//   onNew?: () => void;
// }

// export function PageHeader({
//   title,
//   onNew
// }: Props) {

//   return (

//     <Flex
//       justify="space-between"
//       align="center"
//       mb={6}
//     >

//       <Heading
//         size="lg"
//       >
//         {title}
//       </Heading>

//       {onNew && (

//         <Button
//           colorScheme="blue"
//           leftIcon={<FiPlus />}
//           onClick={onNew}
//         >
//           Novo
//         </Button>

//       )}

//     </Flex>
//   );
// }


import {
  Button,
  Flex,
  Heading,
  HStack
} from "@chakra-ui/react";

import { FiPlus } from "react-icons/fi";

interface Props {
  title: string;
  onNew?: () => void;
  actions?: React.ReactNode;
}

export function PageHeader({ title, onNew, actions }: Props) {
  return (
    <Flex justify="space-between" align="center" mb={6}>
      <Heading size="lg">{title}</Heading>

      <HStack spacing={3}>
        {actions}

        {onNew && (
          <Button colorScheme="blue" leftIcon={<FiPlus />} onClick={onNew}>
            Novo
          </Button>
        )}
      </HStack>
    </Flex>
  );
}